import React, { useState,useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import "./style.css";
import { fetchSearch, updateEducation } from "../../../Redux/Actions/ProfileSteps";
import { useDebouncedSearchDispatch } from "../../../helper/UseDebouncedSearchDispatch";
import AutocompleteInput from "../../../helper/AutocompleteField";
import DatePicker from "react-date-picker";
import moment from "moment";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
const withOthers = (selectedText, othersText) => {
  const sel = (selectedText || "").trim();
  const oth = (othersText || "").trim();
  if (!sel) return "";
  if (sel.toLowerCase() !== "others") return sel;
  return oth ? `${sel} - ${oth}` : sel;
};

const Education = ({ setCurrentStep }) => {
  const dispatch = useDispatch()
  const [edu, setEdu] = useState({});
  const kids = useSelector((state) => state.dashboard.kids);
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const [isChanged, setIsChanged] = useState({});
  const [prefillData,setPrefillData] = useState({})
  const [show,setShow] =useState(prefillData?.highestQualification)

    const showPG = prefillData?.highestQualification === "Post Graduation" || prefillData == {};
  const showGrad = prefillData?.highestQualification === "Post Graduation" || prefillData?.highestQualification === "Graduation";
  const showSchool = prefillData?.highestQualification === "Post Graduation" || prefillData?.highestQualification === "Graduation" || prefillData?.highestQualification === "High School";


  const [postGradDegreeSearch, setPostGradDegreeSearch] = useState('');
  const [postGradCollegeSearch, setPostGradCollegeSearch] = useState('');
  const [postGradSpecializationSearch, setPostGradSpecializationSearch] = useState('');
  const [undergradCollegeSearch, setUndergradCollegeSearch] = useState('');
  const [undergradUniversitySearch, setUndergradUniversitySearch] = useState('');
  const [undergradDegreeSearch, setUndergradDegreeSearch] = useState('');
  const [undergradSpecializationSearch, setUndergradSpecializationSearch] = useState('');
  const [classTwelfthStreamSearch, setClassTwelfthStreamSearch] = useState('');
  const [classTenthSearch, setClassTenthSearch] = useState('');
  const [classTwelfthSearch, setClassTwelfthSearch] = useState('');


  const [postGradDegreeText, setPostGradDegreeText] = useState('');
  const [postGradCollegeText, setPostGradCollegeText] = useState('');
  const [postGradSpecializationText, setPostGradSpecializationText] = useState('');
  const [undergradCollegeText, setUndergradCollegeText] = useState('');
  const [undergradUniversityText, setUndergradUniversityText] = useState('');
  const [undergradDegreeText, setUndergradDegreeText] = useState('');
  const [undergradSpecializationText, setUndergradSpecializationText] = useState('');
  const [classTwelfthStreamText, setClassTwelfthStreamText] = useState('');
  const [classTenthText, setClassTenthText] = useState('');
  const [classTwelfthText, setClassTwelfthText] = useState('');



  const [postGradDegreeOthers, setPostGradDegreeOthers] = useState('');
  const [postGradCollegeOthers, setPostGradCollegeOthers] = useState('');
  const [postGradSpecializationOthers, setPostGradSpecializationOthers] = useState('');
  const [undergradCollegeOthers, setUndergradCollegeOthers] = useState('');
  const [undergradUniversityOthers, setUndergradUniversityOthers] = useState('');
  const [undergradDegreeOthers, setUndergradDegreeOthers] = useState('');
  const [undergradSpecializationOthers, setUndergradSpecializationOthers] = useState('');
  const [classTwelfthOthers, setClassTwelfthOthers] = useState('');
  const [classTwelfthStreamOthers, setClassTwelfthStreamOthers] = useState('');
  const [classTenthOthers, setClassTenthOthers] = useState('');



  const graduation_degree = useSelector(s => s.ProfileSteps.searchByField.graduation_degree);
  const postGradDegree = useSelector(s => s.ProfileSteps.searchByField.postGradDegree);
  const postGradCollege = useSelector(s => s.ProfileSteps.searchByField.postGradCollege);
  const postGradSpecialization = useSelector(s => s.ProfileSteps.searchByField.postGradSpecialization);
  const undergradCollege = useSelector(s => s.ProfileSteps.searchByField.undergradCollege);
  const undergradDegree = useSelector(s => s.ProfileSteps.searchByField.undergradDegree);
  const undergradUniversity = useSelector(s => s.ProfileSteps.searchByField.undergradUniversity);
  const undergradSpecialization = useSelector(s => s.ProfileSteps.searchByField.underGradSpecialization);
  const classTwelfth = useSelector(s => s.ProfileSteps.searchByField.classTwelfth);
  const classTwelfthStream = useSelector(s => s.ProfileSteps.searchByField.classTwelfthStream);
  const classTenth = useSelector(s => s.ProfileSteps.searchByField.classTenth);
useDebouncedSearchDispatch({
  value: postGradCollegeSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "postGradCollege",
  context: "postGradCollege",
});
useDebouncedSearchDispatch({
    value: postGradDegreeSearch,
    dispatch,
    fetchAction: fetchSearch,
    search_type: "postGradDegree",
    context: "postGradDegree",
});
useDebouncedSearchDispatch({
    value: postGradSpecializationSearch,
    dispatch,
    fetchAction: fetchSearch,
    search_type: "postGradSpecialization",
    context: "postGradSpecialization",
});

useDebouncedSearchDispatch({
  value: undergradCollegeSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "undergradCollege",
  context: "undergradCollege",
});
useDebouncedSearchDispatch({
  value: undergradUniversitySearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "undergradCollege",
  context: "undergradUniversity",
});
useDebouncedSearchDispatch({
  value: undergradDegreeSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "gradDegree",
  context: "undergradDegree",
});
useDebouncedSearchDispatch({
  value: undergradSpecializationSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "underGradSpecialization",
  context: "underGradSpecialization",
});
useDebouncedSearchDispatch({
  value: classTenthSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "class10thBoard",
  context: "classTenth",
});
useDebouncedSearchDispatch({
  value: classTwelfthSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "class12thBoard",
  context: "classTwelfth",
});
useDebouncedSearchDispatch({
  value: classTwelfthStreamSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "cass12thStream",
  context: "classTwelfthStream",
});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEdu((prev) => ({ ...prev, [name]: value }));
    setIsChanged((prev) => ({ ...prev, [name]: true }));
    if (name === "highestQualification") {
      setShow(value)
    }

  };
const cgpaRegexWhileTyping = /^(?:\d{0,3})(?:\.\d{0,2})?$/; // allow "", "0", "0.", "0.1", "100", "100.00"

const handleCgpaChange = (e) => {
  const { name, value } = e.target;

  if (value === "" || cgpaRegexWhileTyping.test(value)) {
    const num = Number(value);
    if (value === "" || Number.isNaN(num) || num <= 100) {
      handleChange(e); 
    }
  }
};

const handleCgpaBlur = (e) => {
  const { name, value } = e.target;
  if (value === "") return;

  const num = Number(value);

  const finalOk = /^(?:100(?:\.(?:0{1,2})?)?|(?:\d{1,2})(?:\.\d{1,2})?)$/.test(value) && num >= 0 && num <= 100;

  if (!finalOk) {

    const clamped = Math.min(100, Math.max(0, num));
    const fixed = Number.isFinite(clamped) ? clamped.toFixed(2) : "";
  }
};

const handleSaveAndNext = async() => {
  try{
  const payload = {
    ...edu,

    // PG
    ...(edu?.post_graduation_college
      ? { post_graduation_college: withOthers(edu.post_graduation_college, postGradCollegeOthers) }
      : {}),

    ...(edu?.post_graduation_degree
      ? { post_graduation_degree: withOthers(edu.post_graduation_degree, postGradDegreeOthers) }
      : {}),

    ...(edu?.post_graduation_specialization
      ? { post_graduation_specialization: withOthers(edu.post_graduation_specialization, postGradSpecializationOthers) }
      : {}),

    // Grad
    ...(edu?.graduation_college
      ? { graduation_college: withOthers(edu.graduation_college, undergradCollegeOthers) }
      : {}),

    ...(edu?.graduation_university
      ? { graduation_university: withOthers(edu.graduation_university, undergradUniversityOthers) }
      : {}),

    ...(edu?.graduation_degree
      ? { graduation_degree: withOthers(edu.graduation_degree, undergradDegreeOthers) }
      : {}),

    ...(edu?.graduation_specialization
      ? { graduation_specialization: withOthers(edu.graduation_specialization, undergradSpecializationOthers) }
      : {}),

    // School
    ...(edu?.twelfth_stream
      ? { twelfth_stream: withOthers(edu.twelfth_stream, classTwelfthOthers) }
      : {}),
  };
  const hasData = payload && Object.keys(payload).length > 0;

  if (hasData) {
    const updatedpayload = {
      ...payload,
      kid_id: kids?.[0]?.id,
      // preferred_job_location: Array.isArray(payload.preferred_job_location)
      //   ? payload.preferred_job_location
      //       .map((s) => (typeof s === "string" ? s.trim() : String(s)))
      //       .filter(Boolean)
      //       .join(", ")
      //   : payload.preferred_job_location,
    };
    await dispatch(updateEducation(updatedpayload));

  } else {
  }
setCurrentStep(5)
}catch{
  console.log("error in education step");
  }
};

// const handleDobChange = (name ,date) => {
//   const formattedDate = date ? date.toISOString().slice(0, 10) : "";
//   setEdu((prev) => ({ ...prev, [name]: formattedDate }));
// };
const handleDobChange = (name,date) => {
  if (!date) {
    setEdu((prev) => ({ ...prev, [name]: "" }));
    return;
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  
  setEdu((prev) => ({ ...prev, [name]: formattedDate }));
};

useEffect(() => {
  let highestQualification = "high School"; // default value
  
  const keys = Object.keys(profileData);
  
  // Check for post_ prefix (highest priority)
  if (keys.some(key => key.startsWith("post_"))) {
    highestQualification = "Post Graduation";
  }
  // Check for graduation_ prefix (second priority)
  else if (keys.some(key => key.startsWith("graduation_"))) {
    highestQualification = "Graduation";
  }
  
  setPrefillData({
    // ...profileData,
    highestQualification: highestQualification
  });
  setShow(highestQualification)
}, [profileData]); 
  return (
    <>
      <div className="container-fluid">
        <div className="col-md-8 offset-md-2 py-5">
          <div className="form-bg p-0">
            <div className="form-group p-30-50 pb-0 mb-0">
              <label>Highest Qualification</label>

              <div className="custom-radio-main d-flex gap-3 gap-lg-4">
                <label className="radio-wrapper form-checkbox radiobox my-3">
                  <input
                    type="radio"
                    name="highestQualification"
                    className="form-check-input"
                    value="Post Graduation"
                    checked={isChanged?.highestQualification ? edu.highestQualification === "Post Graduation" : prefillData?.highestQualification === "Post Graduation"}
                    onChange={handleChange}
                  />
                  <span className="checkmark form-check-label">Post Graduation</span>
                </label>

                <label className="radio-wrapper form-checkbox radiobox my-3">
                  <input
                    type="radio"
                    name="highestQualification"
                    className="form-check-input"
                    value="Graduation"
                    checked={isChanged?.highestQualification ? edu.highestQualification === "Graduation" : prefillData?.highestQualification === "Graduation"}
                    onChange={handleChange}
                  />
                  <span className="checkmark form-check-label">Graduation</span>
                </label>

                <label className="radio-wrapper form-checkbox radiobox my-3">
                  <input
                    type="radio"
                    name="highestQualification"
                    className="form-check-input"
                    value="High School"
                    checked={isChanged?.highestQualification ? edu.highestQualification === "High School" : prefillData?.highestQualification === "High School"}
                    onChange={handleChange}
                  />
                  <span className="checkmark form-check-label">High School</span>
                </label>
              </div>
            </div>

            {show == "Post Graduation" && (
              <div className="post-graduation p-30-50 pt-3">
                <AutocompleteInput
                    label="Post Graduation College Name"
                    name="post_graduation_college"
                    value={isChanged?.post_graduation_college? postGradCollegeText : profileData?.post_graduation_college}
                    placeholder="Search college..."
                    suggestions={postGradCollege}
                    onInputValueChange={(text) => {
                        setPostGradCollegeSearch(text);
                        setPostGradCollegeText(text);
                        setIsChanged((prev) => ({ ...prev, post_graduation_college: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, post_graduation_college: item.object_name,college_id: item.object_id }));
                        setPostGradCollegeSearch("");
                        setPostGradCollegeText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setPostGradCollegeOthers(value);
                    }}
                    />

                <div className="row">
                  <div className="col-lg-6">
                    <AutocompleteInput
                    label="Post Graduation Degree"
                    name="post_graduation_degree"
                    value={isChanged?.post_graduation_degree ? postGradDegreeText : profileData?.post_graduation_degree}
                    placeholder="Search degree..."
                    suggestions={postGradDegree}
                    onInputValueChange={(text) => {
                        setPostGradDegreeSearch(text);
                        setPostGradDegreeText(text);
                        setIsChanged((prev) => ({ ...prev, post_graduation_degree: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, post_graduation_degree: item.object_name ,post_grad_degree: item.object_id}));
                        setPostGradDegreeSearch("");
                        setPostGradDegreeText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setPostGradDegreeOthers(value);
                    }}
                    />
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Post Graduation CGPA</label>
                     <input
                        name="post_graduation_cgpa"
                        type="text"
                        inputMode="decimal"
                        className="form-control"
                        placeholder="CGPA"
                        value={isChanged?.post_graduation_cgpa ? edu?.post_graduation_cgpa : profileData?.post_graduation_cgpa}
                        onChange={handleCgpaChange}
                        onBlur={handleCgpaBlur}
                      />

                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Post Graduation Start Date</label>
                      <DatePicker
                  className="form-control"
                  name="post_graduation_start_date"
                  onChange={(date) => handleDobChange("post_graduation_start_date",date)}
                  value={(edu?.post_graduation_start_date && moment(edu?.post_graduation_start_date).format("YYYY-MM-DD")) || (profileData?.post_graduation_start_date && moment(profileData?.post_graduation_start_date).format("YYYY-MM-DD"))}
                  defaultValue={new Date()}
                  maxDate={new Date()}
                  format="dd/MM/y"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Post Graduation End Date</label>
                      <DatePicker
                  className="form-control"
                  name="post_graduation_end_date"
                  onChange={(date) => handleDobChange("post_graduation_end_date",date)}
                  value={(edu?.post_graduation_end_date && moment(edu?.post_graduation_end_date).format("YYYY-MM-DD") || (profileData?.post_graduation_end_date && moment(profileData?.post_graduation_end_date).format("YYYY-MM-DD")))}
                  defaultValue={new Date()}
                  // maxDate={new Date()}
                  format="dd/MM/y"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
                    </div>
                  </div>
                </div>

                <AutocompleteInput
                    label="Post Graduation Specialization"
                    name="postGradSpecialization"
                    value={isChanged?.post_graduation_specialization ? postGradSpecializationText : profileData?.post_graduation_specialization}
                    placeholder="Search Specialization..."
                    suggestions={postGradSpecialization}
                    onInputValueChange={(text) => {
                        setPostGradSpecializationSearch(text);
                        setPostGradSpecializationText(text);
                        setIsChanged((prev) => ({ ...prev, post_graduation_specialization: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, post_graduation_specialization: item.object_name, post_grad_spec : item.object_id }));
                        setPostGradSpecializationSearch("");
                        setPostGradSpecializationText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setPostGradSpecializationOthers(value);
                    }}
                    />
              </div>
            )}

            {showPG && (showGrad || showSchool) && <div className="divider-line"></div>}
            {(show === "Graduation" || show === "Post Graduation") && (
              <div className="graduation p-30-50">
                <AutocompleteInput
                    label="Graduation College Name"
                    name="graduation_college"
                    value={isChanged?.graduation_college ? undergradCollegeText : profileData?.graduation_college}
                    placeholder="Search college..."
                    suggestions={undergradCollege}
                    onInputValueChange={(text) => {
                        setUndergradCollegeSearch(text);
                        setUndergradCollegeText(text);
                        setIsChanged((prev) => ({ ...prev, graduation_college: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, graduation_college: item.object_name, undergrad_college_id : item.object_id }));
                        setUndergradCollegeSearch("");
                        setUndergradCollegeText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setUndergradCollegeOthers(value);
                    }}
                    />

                <AutocompleteInput
                    label="Graduation University Name"
                    name="graduation_university"
                    value={ isChanged?.graduation_university ? undergradUniversityText : profileData?.graduation_university}
                    placeholder="Search university..."
                    suggestions={undergradUniversity}
                    onInputValueChange={(text) => {
                        setUndergradUniversitySearch(text);
                        setUndergradUniversityText(text);
                        setIsChanged((prev) => ({ ...prev, graduation_university: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, graduation_university: item.object_name, undergrad_university_id : item.object_id }));
                        setUndergradUniversitySearch("");
                        setUndergradUniversityText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setUndergradUniversityOthers(value);
                    }}
                    />

                <div className="row">
                  <div className="col-lg-6">
                    <AutocompleteInput
                    label="Graduation Degree"
                    name="graduation_degree"
                    value={isChanged?.graduation_degree ? undergradDegreeText : profileData?.graduation_degree}
                    placeholder="Search degree..."
                    suggestions={undergradDegree}
                    onInputValueChange={(text) => {
                        setUndergradDegreeSearch(text);
                        setUndergradDegreeText(text);
                        setIsChanged((prev) => ({ ...prev, graduation_degree: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, graduation_degree: item.object_name, undergrad_degree : item.object_id }));
                        setUndergradDegreeSearch("");
                        setUndergradDegreeText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setUndergradDegreeOthers(value);
                    }}
                    />
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Graduation CGPA</label>
                      <input
                        name="graduation_cgpa"
                        type="text"
                        inputMode="decimal"
                        className="form-control"
                        placeholder="CGPA"
                        value={ isChanged?.graduation_cgpa ? edu?.graduation_cgpa : profileData?.graduation_cgpa}
                        onChange={handleCgpaChange}
                        onBlur={handleCgpaBlur}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Graduation Start Date</label>
                      <DatePicker
                  className="form-control"
                  name="graduation_start_date"
                  onChange={(date) => handleDobChange("graduation_start_date",date)}
                  value={(edu?.graduation_start_date && moment(edu?.graduation_start_date).format("YYYY-MM-DD") || (profileData?.graduation_start_date && moment(profileData?.graduation_start_date).format("YYYY-MM-DD")))}
                  defaultValue={new Date()}
                  maxDate={new Date()}
                  format="dd/MM/y"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Graduation End Date</label>
                      <DatePicker
                  className="form-control"
                  name="graduation_end_date"
                  onChange={(date) => handleDobChange("graduation_end_date",date)}
                  value={(edu?.graduation_end_date && moment(edu?.graduation_end_date).format("YYYY-MM-DD") || (profileData?.graduation_end_date && moment(profileData?.graduation_end_date).format("YYYY-MM-DD")))}
                  defaultValue={new Date()}
                  // maxDate={new Date()}
                  format="dd/MM/y"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
                    </div>
                  </div>
                </div>
                <AutocompleteInput
                    label="Graduation Specialization"
                    name="graduation_specialization"
                    value={isChanged?.graduation_specialization ? undergradSpecializationText : profileData?.graduation_specialization}
                    placeholder="Search specialization..."
                    suggestions={undergradSpecialization}
                    onInputValueChange={(text) => {
                        setUndergradSpecializationSearch(text);
                        setUndergradSpecializationText(text);
                        setIsChanged((prev) => ({ ...prev, graduation_specialization: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, graduation_specialization: item.object_name, under_grad_spec : item.object_id }));
                        setUndergradSpecializationSearch("");
                        setUndergradSpecializationText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setUndergradSpecializationOthers(value);
                    }}
                    />
              </div>
            )}

            {showGrad && showSchool && <div className="divider-line"></div>}

            {(show === "Graduation" || show === "Post Graduation" || show === "High School") && (
              <>
                <div className="Twelfth p-30-50">
                  <div className="form-group">
                    <div className="col-lg-12">
                      <label>Class 12th Percentage</label>
                      <input
                        name="twelfth_percentage"
                        type="text"
                        inputMode="decimal"
                        className="form-control"
                        placeholder="Percentage"
                        value={isChanged?.twelfth_percentage ? edu?.twelfth_percentage : profileData?.twelfth_percentage}
                        onChange={handleCgpaChange}
                        onBlur={handleCgpaBlur}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <AutocompleteInput
                    label="Class 12th Board"
                    name="twelfth_board_name"
                    value={isChanged?.twelfth_board_name ? classTwelfthText : profileData?.twelfth_board_name}
                    placeholder="Search board..."
                    suggestions={classTwelfth}
                    onInputValueChange={(text) => {
                        setClassTwelfthSearch(text);
                        setClassTwelfthText(text);
                        setIsChanged((prev) => ({ ...prev, twelfth_board_name: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, twelfth_board_name: item.object_id }));
                        setClassTwelfthSearch("");
                        setClassTwelfthText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setClassTwelfthOthers(value);
                    }}
                    />
                    </div>

                    <div className="col-lg-6">
                        <AutocompleteInput
                    label="Class 12th Stream"
                    name="twelfth_stream"
                    value={ isChanged?.twelfth_stream ? classTwelfthStreamText : profileData?.twelfth_stream}
                    placeholder="Search stream..."
                    suggestions={classTwelfthStream}
                    onInputValueChange={(text) => {
                        setClassTwelfthStreamSearch(text);
                        setClassTwelfthStreamText(text);
                        setIsChanged((prev) => ({ ...prev, twelfth_stream: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, twelfth_stream: item.object_name }));
                        setClassTwelfthStreamSearch("");
                        setClassTwelfthStreamText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setClassTwelfthStreamOthers(value);
                    }}
                    />
                    </div>
                  </div>
                </div>

                <div className="divider-line"></div>

                <div className="tength p-30-50">
                  <div className="row">
                    <div className="col-lg-6">
                       <AutocompleteInput
                    label="Class 10th Board"
                    name="tenth_board_name"
                    value={ isChanged?.tenth_board_name ? classTenthText : profileData?.tenth_board_name}
                    placeholder="Search board..."
                    suggestions={classTenth}
                    onInputValueChange={(text) => {
                        setClassTenthSearch(text);
                        setClassTenthText(text);
                        setIsChanged((prev) => ({ ...prev, tenth_board_name: true }));
                    }}
                    onSelectSuggestion={(item) => {
                        setEdu((prev) => ({ ...prev, tenth_board_name: item.object_id }));
                        setClassTenthSearch("");
                        setClassTenthText(item.object_name);
                    }}
                    onOthersSelect={(value) => {
                      setClassTenthOthers(value);
                    }}
                    />
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                    <div className="col-lg-12">
                      <label>Class 10th Percentage</label>
                      <input
                        name="tenth_percentage"
                        type="text"
                        inputMode="decimal"
                        className="form-control"
                        placeholder="Percentage"
                        value={ isChanged?.tenth_percentage ? edu?.tenth_percentage : profileData?.tenth_percentage}
                        onChange={handleCgpaChange}
                        onBlur={handleCgpaBlur}
                      />
                    </div>
                  </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
          <button className='default-btn default-border bg-transparent back-btn me-3'><img src="./images/back-arrow.png"  className='d-block d-md-none'/><span className='d-none d-md-block' onClick={() => setCurrentStep(3)}>Back</span></button>
          <button
            className="default-btn default-border bg-transparent me-3"
            onClick={() => setCurrentStep(5)}
          >
            Skip
          </button>

          <button className="default-btn" onClick={handleSaveAndNext}>
            Save & Next
          </button>
        </div>
      </div> 
    </>
  );
};

export default Education;
